(($, Drupal) => {
  Drupal.behaviors.YT = {
    attach: function attach(context) {
      $('.youtube-wrapper', context).once('YT').each((index, element) => {
        const $modal = $(element).find('.youtube-modal');
        const $player = $(element).find('.js-youtube-player');

        $modal.addClass('active');

        const iframe = document.createElement('iframe');
        const embed = 'https://www.youtube.com/embed/ID';
        const getYTVideoID = (url) => {
          let newval = '';

          if (url.match(/(\?|&)v=([^&#]+)/)) {
            newval = url.match(/(\?|&)v=([^&#]+)/);
          } else if (url.match(/(\.be\/)+([^\/]+)/)) {
            newval = url.match(/(\.be\/)+([^\/]+)/);
          } else if (url.match(/(\embed\/)+([^\/]+)/)) {
            newval = url.match(/(\embed\/)+([^\/]+)/);
          }
          return newval.pop().replace('?rel=0', '');
        };
        const id = getYTVideoID($player.attr('data-id'));

        iframe.setAttribute('src', embed.replace('ID', id));
        iframe.setAttribute('allowfullscreen', 'allowfullscreen');

        $player.append(iframe);
      });
    },
  };
})(jQuery, Drupal);
